import { render, staticRenderFns } from "./giftExchangeDeadline.vue?vue&type=template&id=5127580a"
import script from "./giftExchangeDeadline.vue?vue&type=script&lang=js"
export * from "./giftExchangeDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports